import { backgrounds } from "assets/backgrounds";
import { DashboardProps } from "types/GlobalData";

export const getRandomBackground = (dashboards: DashboardProps[]): string => {
  const usedBg = dashboards.map((d) => d.backgroundName);
  const freeBg = Object.keys(backgrounds).filter((bgName) => !usedBg.includes(bgName));
  const maxLimit = freeBg.length >= 1 ? freeBg.length - 1 : 0;

  return freeBg[Math.floor(Math.random() * maxLimit)];
};
